module.exports = __webpack_public_path__ + "static/media/background10.806b4c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/background10.png
// module id = 50
// module chunks = 0